<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  name: 'TriggerProxy',
});
</script>
<template>
  <!-- eslint-disable vue/valid-v-slot -->
  <div style="width:100%">
    <slot v-slot />
  </div>
  <!-- eslint-enable vue/valid-v-slot -->
</template>
